import cx from 'classnames';
import styles from 'partials/data-table/data-table.module.scss';

export const DataTable = ({ children, className }) => {
	const tableClass = cx(styles.table, className);
	return <div className={tableClass}>{children}</div>;
};
